export const Bullet_List = `
<h3>Bullet List</h3>
<hr />
<article id="bullet-list">
   <div class="row">
      <div class="col-lg-3 d-none d-lg-block"></div>
      <div class="col-lg-7 col-md-12">
         <div class="intro-copy">
            Confidence is <b>the feeling that no matter what comes your way, you will succeed.</b>
         </div>
         <ul>
            <li id="bullet-listitem1">Health</li>
            <li id="bullet-listitem2">Relationships</li>
            <li id="bullet-listitem3">Resilience</li>
            <li id="bullet-listitem4">Your ability to cope with stress.</li>
            <li id="bullet-listitem5"></li>
            <li id="bullet-listitem6"></li>
            <li id="bullet-listitem7"></li>
            <li id="bullet-listitem8"></li>
            <li id="bullet-listitem9"></li>
            <li id="bullet-listitem10"></li>
         </ul>
         <div class="intro-copy">
            Confidence helps you feel like the version of yourself that you were meant to be.
         </div>
         <div class="col-lg-2 d-none d-lg-block"></div>
      </div>
   </div>
</article>
`;

